import { AuthWrapper } from "./AuthWrapper";
import { Hub } from "@aws-amplify/core";
export class AuthListener {
    constructor(callback, notifyRetroactively) {
        this.removeHandle = Hub.listen("auth", (data) => AuthListener.listener(data.payload.event, callback));
        if (notifyRetroactively) {
            // if the has authenticated before the listener is registered,
            // retroactively notify the listener creator about the situation
            AuthWrapper.isCurrentUserAuthenticated().then((authenticated) => {
                if (authenticated) {
                    callback("SignedIn");
                }
            });
        }
    }
    static listener(event, callback) {
        switch (event) {
            case "signIn":
                callback("SignedIn");
                break;
            case "signUp":
                callback("SignedUp");
                break;
            case "signOut":
                callback("SignedOut");
                break;
            case "signIn_failure":
                callback("SignInFailed");
                break;
        }
    }
    removeListener() {
        var _a;
        (_a = this.removeHandle) === null || _a === void 0 ? void 0 : _a.call(this);
        this.removeHandle = undefined;
    }
}
